import Button from '@/components/Button.jsx';
import { FiArrowLeft } from '@/components/react-icons/main';

const WizardNavigation = ({ canGoBack, canGoNext, onBack, onNext, hideIfNoNext = false, hideNextIfNoNext = false }) => {
  if (hideIfNoNext && !canGoNext) {
    return null;
  }

  const showNext = !(hideNextIfNoNext && !canGoNext);

  return (
    <div className="comp-wizard-navigation">
      <Button className={'outline'} size="lg" onClick={onBack} icon={FiArrowLeft} disabled={!canGoBack}>
        Back
      </Button>
      {showNext && (
        <Button className={'primary'} size="lg" onClick={onNext} disabled={!canGoNext}>
          Next
        </Button>
      )}
    </div>
  );
};

export default WizardNavigation;
